import { Link } from 'react-router-dom'
import { cn, focusRing } from '@insightai/ui'

const COLUMNS = [
  {
    heading: 'Platform',
    links: [
      { to: '/solutions', label: 'Capabilities' },
      { to: '/methodology', label: 'Methodology' },
      { to: '/pricing', label: 'Pricing' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { to: '/resources', label: 'Guides & notes' },
      { to: '/methodology#governance', label: 'AI governance' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { to: '/legal/privacy', label: 'Privacy Policy' },
      { to: '/legal/terms', label: 'Terms of Service' },
    ],
  },
]

/** M00-10 — footer, legal links and the cookie notice. */
export function SiteFooter() {
  return (
    <footer className="border-t border-border-subtle bg-surface-raised">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:grid-cols-2 sm:px-6 lg:grid-cols-4">
        <div className="flex flex-col gap-2">
          <p className="text-body font-semibold">InsightAI</p>
          <p className="max-w-xs text-body-sm text-text-secondary">
            AI-orchestrated market research with provenance you can defend in a boardroom.
          </p>
        </div>

        {COLUMNS.map((column) => (
          <nav key={column.heading} aria-label={column.heading} className="flex flex-col gap-2">
            <h2 className="text-micro uppercase tracking-wide text-text-tertiary">{column.heading}</h2>
            <ul className="flex flex-col gap-1.5">
              {column.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className={cn(
                      'rounded-sm text-body-sm text-text-secondary hover:text-text-primary',
                      focusRing,
                    )}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="border-t border-border-subtle px-4 py-6 sm:px-6">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 text-caption text-text-tertiary sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} InsightAI. All rights reserved.</p>
          {/* Only strictly necessary cookies are set pre-consent (the theme
              preference and the PKCE state), so a banner is not required — this
              states that plainly instead of interrupting first paint. */}
          <p>
            We set only essential cookies — your theme preference and sign-in state. No advertising
            or tracking cookies.
          </p>
        </div>
      </div>
    </footer>
  )
}
